<script lang="ts" setup>
/**
 * UI-kit component
 * Category: Buttons
 * Name: 'Primary'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=212-73562&m=dev'
 */
import { IconContainer } from '@shared/ui/icon'
import { TooltipDefault } from '@shared/ui/tooltip'

defineOptions({
  name: 'BtnPrimary',
})

withDefaults(defineProps<BtnPrimaryProps>(), {
  text: '',
  disabled: false,
  color: 'blue',
  size: 'medium',
  elementWidth: 'auto',
  tooltip: null,
  dataQa: null,
})

const emit = defineEmits<{
  click: []
}>()

interface BtnPrimaryProps {
  text?: string
  disabled?: boolean
  color?: 'blue' | 'orange' | 'amber' | 'red'
  size?: 'big' | 'medium' | 'small'
  elementWidth?: 'auto' | 'full'
  tooltip?: string | null
  dataQa?: string | null
}
const handleClick = (): void => {
  emit('click')
}
</script>

<template>
  <button
    type="button"
    :class="['ui-btn-primary', color, size, elementWidth, { tooltip }]"
    :data-qa="dataQa"
    :disabled="disabled"
    @click="handleClick"
  >
    <IconContainer
      v-if="$slots.iconLeft"
      :class="[size]"
    >
      <slot name="iconLeft" />
    </IconContainer>
    <slot
      v-if="$slots.content"
      name="content"
    />
    <span
      v-else
      class="ui-btn-primary__text"
    >
      {{ text }}
    </span>
    <IconContainer
      v-if="$slots.iconRight"
      :class="[`container-${size}`]"
    >
      <slot
        name="iconRight"
      />
    </IconContainer>
    <TooltipDefault
      v-if="tooltip"
      class="tooltip-default"
      :text="tooltip"
      size="small"
    />
  </button>
</template>

<style scoped lang="scss" src="./BtnPrimary.scss" />
